import { BrandLogo } from "./BrandLogo";


export const Footer = () => {  return (
    <footer data-testid="footer" className="relative bg-[#030303] border-t border-white/10 pt-24 pb-12 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* master logo + tagline */}
        <div className="flex flex-col sm:flex-row sm:items-center gap-6 mb-14">
          <BrandLogo size="lg" />
          <div className="serif italic text-2xl lg:text-3xl text-[#f4f0ea] sm:border-l sm:border-white/10 sm:pl-6">Protecting what matters most.</div>
        </div>

        {/* giant brand line */}
        <div className="mb-20 select-none">
          <div className="serif font-light text-[#f4f0ea] leading-[0.9] text-[13vw] lg:text-[9vw] flex flex-wrap items-baseline gap-x-[0.28em]">
            <span>John</span>
            <span className="flex flex-col leading-[0.88]">
              <span className="italic text-[#d4af37]">Campbell</span>
              <span className="text-[#d4af37] text-[6.5vw] lg:text-[4.6vw] tracking-tight mt-[0.06em]">Insurance</span>
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-12 border-t border-white/10 pt-14">
          <div className="md:col-span-2 max-w-md">
            <p className="text-[#a3a3a3] leading-relaxed tracking-wide">
              Independent life insurance brokerage. Personalized term, whole, and universal
              coverage compared across 25+ A-rated or better insurance carriers — engineered around your legacy.
            </p>
          </div>

          <div>
            <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-5">Explore</div>
            <ul className="space-y-3">
              {[["About", "/#about"], ["Coverages", "/#products"], ["Life Insurance in Chandler, AZ", "/life-insurance-chandler-az"], ["Client Experiences", "/client-experiences"], ["Get a Quote", "/#quote"], ["Contact", "/#contact"], ["Careers", "/join"]].map(([l, h]) => (
                <li key={l}>
                  <a href={h} className="text-[#f4f0ea]/80 hover:text-[#d4af37] link-underline transition-colors">{l}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="mono text-[10px] uppercase tracking-[0.25em] text-[#737373] mb-5">Reach us</div>
            <ul className="space-y-3">
              <li><a href="mailto:John@johncampbellinsurance.com" className="text-[#f4f0ea]/80 hover:text-[#d4af37] link-underline whitespace-nowrap">John@johncampbellinsurance.com</a></li>
              <li><a href="tel:+16234141766" className="text-[#f4f0ea]/80 hover:text-[#d4af37] link-underline">623-414-1766</a></li>
              <li><a href="https://johncampbellinsurance.com" className="text-[#f4f0ea]/80 hover:text-[#d4af37] link-underline">johncampbellinsurance.com</a></li>
              <li><a href="https://hihello.com/hi/johnacampbellivarizona" target="_blank" rel="noopener noreferrer" data-testid="footer-hihello" className="text-[#f4f0ea]/80 hover:text-[#d4af37] link-underline">Digital business card ↗</a></li>
              <li className="text-[#737373] text-sm">By Appointment — Arizona and Select States</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mt-20 pt-8 border-t border-white/10">
          <span className="mono text-[10px] uppercase tracking-[0.25em] text-[#737373]">
            © {new Date().getFullYear()} John Campbell Insurance
          </span>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6">
            <a
              href="https://hihello.com/hi/johnacampbellivarizona"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-npn-link"
              className="mono text-[10px] uppercase tracking-[0.25em] text-[#d4af37] hover:text-[#f0d57d] link-underline"
            >
              Licensed Broker · NPN 20047375 ↗
            </a>
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-[#737373]">
              All rights reserved
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
